import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import {
  EstadoCivilKeys,
  IEstadoCivil,
} from "../../../../../../../application/models";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";
import { HeaderFiltro } from "../header-filtro";

export const estadoCivilKeyToLabel = (estadoCivilKey: IEstadoCivil) => {
  switch (estadoCivilKey) {
    case "CASADO":
      return "Casado";
    case "DIVORCIADO":
      return "Divorciado";
    case "OUTROS":
      return "Outros";
    case "SOLTEIRO":
      return "Solteiro";
    case "UNIAO ESTAVEL":
      return "União Estável";
    case "VIUVO":
      return "Viúvo";
    default:
      return "Não definido";
  }
};

export const FiltroEstadoCivil = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
  // Hook
  const { addEstadoCivilFilter, removeEstadoCivilFilter } =
    useProjetosService();

  return (
    <>
      <HeaderFiltro
        titulo="Estado Civil"
        descricao={
          <>
            <Typography>
              Esta opção permite buscar pessoas através do estado civil.
            </Typography>
            <Typography style={{ marginBottom: "10px" }}>
              Você pode acessar a lista de estados civis disponíveis e
              selecionar quantos desejar.
            </Typography>
            <Typography>
              Caso nenhuma opção seja selecionada, consideraremos todas.
            </Typography>
          </>
        }
      />
      <Box p={3} style={{ marginTop: "10px" }}>
        <Grid container spacing={3}>
          {EstadoCivilKeys.map((estadoCivil) => (
            <Grid item xs={6} key={estadoCivil}>
              {" "}
              {/* key agora corretamente atribuída */}
              <FormControlLabel
                label={estadoCivilKeyToLabel(estadoCivil).toUpperCase()}
                control={
                  <Switch
                    checked={
                      filtrosSelecionados?.estadoCivil?.includes(estadoCivil) ??
                      false
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        addEstadoCivilFilter(estadoCivil);
                      } else {
                        removeEstadoCivilFilter(estadoCivil);
                      }
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};
